import React, { useState, useEffect } from "react";
import "./HeroSection.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeaf, faFlask, faStar } from "@fortawesome/free-solid-svg-icons";
const HeroSection = () => {
    const [currentText, setCurrentText] = useState(0);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

    const rotatingTexts = [
        "Crystal Clear Results",
        "Nature's Intelligence",
        "Lab-Perfected Formulas",
        "Eco-Conscious Cleaning"
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentText((prev) => (prev + 1) % rotatingTexts.length);
        }, 2500);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const handleMouseMove = (e) => {
            setMousePosition({
                x: (e.clientX / window.innerWidth) * 100,
                y: (e.clientY / window.innerHeight) * 100
            });
        };

        window.addEventListener('mousemove', handleMouseMove);
        return () => window.removeEventListener('mousemove', handleMouseMove);
    }, []);

    return (
        <div id="home" className="hero-container">
            {/* Advanced Background Layers */}
            <div className="bg-layer base-bg"></div>
            <div
                className="bg-layer gradient-overlay"
                style={{
                    background: `radial-gradient(circle at ${mousePosition.x}% ${mousePosition.y}%, rgba(58, 189, 133, 0.3) 0%, rgba(124, 199, 248, 0.2) 30%, transparent 70%)`
                }}
            ></div>

            {/* Animated Elements */}
            <div className="floating-bubbles">
                {[...Array(15)].map((_, i) => (
                    <div key={i} className="bubble" style={{
                        left: `${Math.random() * 100}%`,
                        animationDelay: `${Math.random() * 5}s`,
                        size: `${20 + Math.random() * 30}px`
                    }}></div>
                ))}
            </div>

         

            {/* Main Content */}
            <div className="hero-content">


                {/* Main Headline */}
                <h1 className="hero-title">
                    <span className="title-line">The Future of Clean</span>
                    <span className="title-line">
                        Is <span className="highlight-text">Here</span>
                    </span>
                </h1>

                {/* Animated Subtitle */}
                <div className="subtitle-container">
                    <p className="hero-subtitle">
                        Experience the revolution where advanced biotechnology meets
                        <span className="rotating-text"> {rotatingTexts[currentText]}</span>
                    </p>
                </div>

                {/* Stats Bar */}
                <div className="stats-bar">
                    <div className="stat">
                        <div className="stat-number">99.9%</div>
                        <div className="stat-label">Effective</div>
                    </div>
                    <div className="stat">
                        <div className="stat-number">100%</div>
                        <div className="stat-label">Natural</div>
                    </div>
                    <div className="stat">
                        <div className="stat-number">24h</div>
                        <div className="stat-label">Protection</div>
                    </div>
                </div>

                {/* CTA Buttons */}
                <div className="cta-container">
                    <button className="cta-btn primary">
                        <span className="btn-glow"></span>
                        <span className="btn-text">
                            Contact Us
                            <svg className="btn-icon" viewBox="0 0 24 24">
                                <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
                            </svg>
                        </span>
                    </button>


                </div>

                {/* Trust Badges */}
                <div className="trust-badges">
                    <div className="trust-item">
                        <FontAwesomeIcon icon={faLeaf} /> Eco Certified
                    </div>
                    <div className="trust-item">
                        <FontAwesomeIcon icon={faFlask} /> Science Backed
                    </div>
                    <div className="trust-item">
                        <FontAwesomeIcon icon={faStar} /> 5-Star Rated
                    </div>
                </div>
            </div>

            {/* Scroll Indicator */}
            {/* Decorative Corner Image */}
            <img
                src="/img/Dishwash_can.png"   // <-- change to your image path
                alt="cleaning bottle"
                className="corner-image"
            />
            <img
                src="/img/Dishwash_can.png"   // <-- change to your image path
                alt="cleaning bottle"
                className="corner-image-2"
            />
              <img
                src="/img/Dishwash_can.png"   // <-- change to your image path
                alt="cleaning bottle"
                className="right-corner-image"
            />
 <img
                src="/img/Dishwash_can.png"   // <-- change to your image path
                alt="cleaning bottle"
                className="right-corner-image-2"
            />


        </div>
    );
};

export default HeroSection;